import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import { ProjectRoleType } from './projectRoleApiTypes';

export const getProjectRoles = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<ProjectRoleType>>(config, `/projectRole`, 'GET', null, commonHeaders);

export const getTemplateRoles = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<ProjectRoleType>>(
        config,
        `/projectRole?template=true`,
        'GET',
        null,
        commonHeaders,
    );
